module.exports = __webpack_public_path__ + "handle-vodafone.70a7d7d80c08e17716db.png";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/images/handle-vodafone.png
// module id = ../../../../../src/assets/images/handle-vodafone.png
// module chunks = styles